(() => {
  const home = document.querySelector('[data-mebore-home-rev="3"]');
  if (!home) return;

  const initHero = () => {
    const track = home.querySelector('[data-hero-track]');
    const slides = [...home.querySelectorAll('[data-hero-slide]')];
    const dots = [...home.querySelectorAll('[data-hero-dot]')];
    if (!track || slides.length === 0) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;
    let pointerStart = null;

    const hydrateSlide = index => {
      const image = slides[index]?.querySelector('img[data-srcset]');
      if (!image) return;
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    };

    const show = (nextIndex, trigger = 'auto') => {
      current = (nextIndex + slides.length) % slides.length;
      if (current > 0) hydrateSlide(current);
      track.style.transform = `translate3d(-${current * 100}%,0,0)`;
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === current ? 'false' : 'true');
        slide.dataset.viewTrigger = index === current ? trigger : '';
      });
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === current);
        dot.setAttribute('aria-selected', index === current ? 'true' : 'false');
      });
      if (current > 0) window.setTimeout(() => hydrateSlide((current + 1) % slides.length), 250);
    };

    const schedule = () => {
      window.clearInterval(timer);
      if (!reducedMotion) timer = window.setInterval(() => show(current + 1, 'auto'), 5500);
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      show(index, 'dot');
      schedule();
    }));

    track.addEventListener('pointerdown', event => {
      pointerStart = { x: event.clientX, y: event.clientY };
    });
    track.addEventListener('pointerup', event => {
      if (!pointerStart) return;
      const deltaX = event.clientX - pointerStart.x;
      const deltaY = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
        show(current + (deltaX < 0 ? 1 : -1), 'swipe');
        schedule();
      }
    });
    track.addEventListener('pointercancel', () => { pointerStart = null; });

    show(0, 'auto');
    const firstImage = slides[0]?.querySelector('img');
    const primeSecondSlide = () => hydrateSlide(1);
    if (firstImage?.complete) primeSecondSlide();
    else firstImage?.addEventListener('load', primeSecondSlide, { once: true });
    window.setTimeout(primeSecondSlide, 1600);
    schedule();
  };

  const resolveProduct = title => window.MeboreReviewProductResolver?.resolve(title) || Promise.resolve(null);

  const buildReviewCard = (source, product, sectionId, position) => {
    const card = document.createElement('article');
    const reviewId = source.dataset.reviewId || `review-${position}`;
    const productUrl = product?.url || '';
    const productId = product?.id || reviewId;
    const productTitle = product?.title || source.querySelector('.jdgm-carousel-item__product-image')?.alt || '商品を見る';
    const sourceImage = source.querySelector('.jdgm-carousel-item__product-image');
    const imageUrl = product?.image || sourceImage?.dataset.src || sourceImage?.currentSrc || sourceImage?.src || '';
    const attributedUrl = productUrl ? `${productUrl}${productUrl.includes('?') ? '&' : '?'}source_section_id=${sectionId}` : '';
    const reviewUrl = attributedUrl;
    const rating = source.querySelector('.jdgm-carousel-item__review-rating, .jdgm-rev__rating')?.getAttribute('aria-label') || '5 stars';
    const starCount = Math.max(1, Math.min(5, Number.parseInt(rating, 10) || 5));
    const title = source.querySelector('.jdgm-carousel-item__review-title, .jdgm-rev__title')?.textContent?.trim() || '';
    const body = source.querySelector('.jdgm-carousel-item__review-body, .jdgm-rev__body')?.textContent?.trim() || '';

    card.className = 'mb-review-card';
    card.dataset.reviewId = reviewId;
    card.dataset.itemId = productId;
    card.dataset.positionInSection = String(position);
    card.dataset.sourceSectionId = sectionId;

    const media = attributedUrl ? document.createElement('a') : document.createElement('span');
    media.className = 'mb-review-card__media';
    if (attributedUrl) {
      media.href = attributedUrl;
      media.dataset.itemId = productId;
      media.dataset.positionInSection = String(position);
      media.dataset.sourceSectionId = sectionId;
    }
    const image = document.createElement('img');
    image.className = 'mb-review-card__image';
    image.src = imageUrl;
    image.alt = productTitle;
    image.width = 56;
    image.height = 56;
    image.loading = 'lazy';
    media.append(image);

    const content = document.createElement('div');
    const productLink = attributedUrl ? document.createElement('a') : document.createElement('span');
    productLink.className = 'mb-review-card__product';
    productLink.textContent = productTitle;
    if (attributedUrl) {
      productLink.href = attributedUrl;
      productLink.dataset.itemId = productId;
      productLink.dataset.positionInSection = String(position);
      productLink.dataset.sourceSectionId = sectionId;
    }
    const stars = document.createElement('p');
    stars.className = 'mb-review-card__stars';
    stars.setAttribute('aria-label', rating);
    stars.textContent = `${'★'.repeat(starCount)}${'☆'.repeat(5 - starCount)}`;
    const reviewLink = reviewUrl ? document.createElement('a') : document.createElement('div');
    reviewLink.className = 'mb-review-card__review-link';
    if (reviewUrl) {
      reviewLink.href = reviewUrl;
      reviewLink.dataset.reviewId = reviewId;
      reviewLink.dataset.itemId = productId;
      reviewLink.dataset.positionInSection = String(position);
      reviewLink.dataset.sourceSectionId = sectionId;
    }
    const reviewTitle = document.createElement('p');
    reviewTitle.className = 'mb-review-card__title';
    reviewTitle.textContent = title;
    const reviewBody = document.createElement('p');
    reviewBody.className = 'mb-review-card__body';
    reviewBody.textContent = body;
    reviewLink.append(reviewTitle, reviewBody);
    content.append(productLink, stars, reviewLink);
    card.append(media, content);
    return card;
  };

  const bridgeJudgeMe = () => {
    const sourceSection = document.querySelector('[id$="__reviews_source"]');
    const topTarget = home.querySelector('[data-review-target="top"]');
    const fullTarget = home.querySelector('[data-review-target="full"]');
    if (!sourceSection || !topTarget || !fullTarget) return;

    let attempts = 0;
    const collect = async () => {
      const items = [...sourceSection.querySelectorAll('.jdgm-carousel-item')]
        .filter((item, index, all) => all.findIndex(other => other.dataset.reviewId === item.dataset.reviewId) === index)
        .slice(0, 15);
      if (items.length < 15 && attempts < 40) {
        attempts += 1;
        window.setTimeout(collect, 250);
        return;
      }
      if (items.length === 0) return;

      const products = await Promise.all(items.map(item => resolveProduct(item.querySelector('.jdgm-carousel-item__product-image')?.alt || '')));
      const ladiesReviews = items
        .map((item, index) => ({ item, product: products[index] }))
        .filter(entry => entry.product?.vendor === 'Mebore');
      const sharedReviews = ladiesReviews.slice(0, 5);
      topTarget.replaceChildren(...sharedReviews.map((entry, index) => buildReviewCard(entry.item, entry.product, 's3_reviews_top', index + 1)));
      fullTarget.replaceChildren(...sharedReviews.map((entry, index) => buildReviewCard(entry.item, entry.product, 's9_reviews_full', index + 1)));
      home.dataset.judgemeSourceCount = String(items.length);
      home.dataset.judgemeLadiesCount = String(ladiesReviews.length);
      home.dataset.judgemeFilter = 'product-vendor:Mebore';
      sourceSection.querySelectorAll('h1,h2,h3').forEach(heading => {
        const replacement = document.createElement('div');
        replacement.className = heading.className;
        replacement.innerHTML = heading.innerHTML;
        heading.replaceWith(replacement);
      });
      sourceSection.hidden = true;
    };
    collect();
  };

  initHero();
  bridgeJudgeMe();
})();
